import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as RecordingReducer from './reducers/recording.reducer';
import { EffectsModule } from '@ngrx/effects';
import { RecordingEffects } from './effects/recording.effects';
import { RecordingService } from './services/recording.service';
import { RecordingStoreFacade } from './facades/recording-store.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      RecordingReducer.recordingFeatureKey,
      RecordingReducer.reducer
    ),
    EffectsModule.forFeature([RecordingEffects]),
  ],
  providers: [RecordingService, RecordingStoreFacade],
})
export class RecordingsStoreModule {}
